import { makeFetchSelectors } from 'app/redux-fetch'

import { RootState } from 'app/store'
import {
  BILLING_CHARGES_LIST_REDUCER_NAME,
  BILLING_HISTORY_REDUCER_NAME,
  GET_BILLING_CHARGES_REDUCER_NAME,
} from './consts'
import { BillingChargeType } from './types'

export const billingChargesSelector = makeFetchSelectors(
  BILLING_HISTORY_REDUCER_NAME,
  GET_BILLING_CHARGES_REDUCER_NAME
)

export const billingChargesListSelector = (
  state: RootState
): BillingChargeType[] =>
  state[BILLING_HISTORY_REDUCER_NAME][BILLING_CHARGES_LIST_REDUCER_NAME].data
    .list

export const billingChargesHasMoreSelector = (state: RootState): boolean =>
  state[BILLING_HISTORY_REDUCER_NAME][BILLING_CHARGES_LIST_REDUCER_NAME].data
    .hasMore
